import Header from './Header';

const Addons = () => <Header label="Additional Services" />;

export default Addons;
